import { render, staticRenderFns } from "./VSwatch.vue?vue&type=template&id=50bc40ed&"
import script from "./VSwatch.vue?vue&type=script&lang=js&"
export * from "./VSwatch.vue?vue&type=script&lang=js&"
import style0 from "./VSwatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports